import StickyNode from 'react-stickynode'
import { number } from 'prop-types'
import { useHeaderStickyTopValue } from '@bluheadless/ui-logic/src/providers/header'
import { useConfig } from '@bluheadless/ui-logic/src/providers/config'
import { forwardRef } from 'react'

const Sticky = forwardRef(function Sticky({ children, offset, ...props }, ref) {
	const {
		stickyHeader: { enabled: stickyHeaderEnabled },
	} = useConfig()

	const { stickyTop } = useHeaderStickyTopValue()

	return (
		<StickyNode {...props} ref={ref} top={stickyHeaderEnabled ? stickyTop + offset : offset}>
			{children}
		</StickyNode>
	)
})

Sticky.defaultProps = {
	...StickyNode.defaultProps,
	offset: 0,
}

Sticky.propTypes = {
	...StickyNode.propTypes,
	offset: number,
}

export default Sticky
